import React from 'react';
import { Link } from 'react-router-dom';

const TermsOfService = ({ userData }) => {
  const defaultAccessCard = userData?.accesscards?.find(
    ac => ac.accesscard_id === userData.default_accesscard_id
  );
  const schoolName = defaultAccessCard?.school?.school_name || 'Acuity CTE';
  const logoUrl = defaultAccessCard?.school?.logo_url || "https://acuitycte-files.s3.us-west-2.amazonaws.com/public/acuity-tech-logo.png";

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <Link to="/sms-notifications" style={styles.backButton}>
          ← Back to SMS Notifications
        </Link>
        <div style={styles.logoSection}>
          <img src={logoUrl} alt="Logo" style={styles.logo} />
          <h1 style={styles.schoolName}>{schoolName}</h1>
        </div>
      </div>

      <div style={styles.content}>
        <h1 style={styles.title}>Terms of Service</h1>
        <p style={styles.lastUpdated}>Last Updated: {new Date().toLocaleDateString()}</p>

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>1. Acceptance of Terms</h2>
          <p style={styles.text}>
            By accessing and using the SMS notification services provided by {schoolName} ("we," "us," or "our"), 
            you accept and agree to be bound by the terms and provision of this agreement. If you do not agree 
            to abide by the above, please do not use this service.
          </p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>2. SMS Notification Service</h2>
          <p style={styles.text}>
            Our SMS notification service allows you to receive informational text messages about:
          </p>
          <ul style={styles.list}>
            <li>Field experience events and opportunities</li>
            <li>Account updates and notifications</li>
            <li>Educational announcements and reminders</li>
            <li>Program updates and changes</li>
          </ul>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>3. Consent to Receive SMS Messages</h2>
          <p style={styles.text}>
            By providing your mobile phone number and checking the consent box, you expressly consent to receive 
            SMS messages from {schoolName} at the phone number you provide. You acknowledge that:
          </p>
          <ul style={styles.list}>
            <li>Consent is not a condition of any purchase or service</li>
            <li>Message frequency will vary based on your preferences and our communications</li>
            <li>Message and data rates may apply as determined by your mobile carrier</li>
            <li>You can opt out at any time by replying "STOP" to any message</li>
            <li>You can get help by replying "HELP" to any message</li>
          </ul>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>4. Opt-Out Instructions</h2>
          <p style={styles.text}>
            You may opt out of receiving SMS messages at any time by:
          </p>
          <ul style={styles.list}>
            <li>Replying "STOP" to any SMS message you receive from us</li>
            <li>Contacting us directly to request removal from our SMS list</li>
            <li>Updating your preferences through your account settings</li>
          </ul>
          <p style={styles.text}>
            After opting out, you may still receive messages that are already in transit or are required 
            for legal or security purposes.
          </p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>5. Message Frequency</h2>
          <p style={styles.text}>
            The frequency of SMS messages will vary based on:
          </p>
          <ul style={styles.list}>
            <li>Your selected notification preferences</li>
            <li>Upcoming events and deadlines</li>
            <li>Important announcements and updates</li>
            <li>Account-related notifications</li>
          </ul>
          <p style={styles.text}>
            We strive to send only relevant and necessary messages to minimize disruption.
          </p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>6. Carrier and Service Limitations</h2>
          <p style={styles.text}>
            SMS delivery is subject to:
          </p>
          <ul style={styles.list}>
            <li>Your mobile carrier's network availability and policies</li>
            <li>Your device's compatibility and settings</li>
            <li>Message and data rates as determined by your carrier</li>
            <li>Potential delays or delivery failures beyond our control</li>
          </ul>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>7. Privacy and Data Protection</h2>
          <p style={styles.text}>
            We are committed to protecting your privacy. Your phone number and message preferences are:
          </p>
          <ul style={styles.list}>
            <li>Stored securely in our database</li>
            <li>Used only for sending SMS notifications as requested</li>
            <li>Not shared with third parties except as required by law</li>
            <li>Protected in accordance with our Privacy Policy</li>
          </ul>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>8. Prohibited Uses</h2>
          <p style={styles.text}>
            You agree not to:
          </p>
          <ul style={styles.list}>
            <li>Provide false or misleading information</li>
            <li>Use the service for any unlawful purpose</li>
            <li>Attempt to circumvent any security measures</li>
            <li>Interfere with the service or its operation</li>
          </ul>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>9. Service Modifications</h2>
          <p style={styles.text}>
            We reserve the right to:
          </p>
          <ul style={styles.list}>
            <li>Modify or discontinue the SMS service at any time</li>
            <li>Update these terms with notice to users</li>
            <li>Limit or restrict access to the service</li>
            <li>Change message frequency or content</li>
          </ul>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>10. Limitation of Liability</h2>
          <p style={styles.text}>
            {schoolName} shall not be liable for any damages arising from:
          </p>
          <ul style={styles.list}>
            <li>Delays or failures in message delivery</li>
            <li>Carrier network issues or limitations</li>
            <li>Device compatibility problems</li>
            <li>Unauthorized access to your information</li>
          </ul>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>11. Contact Information</h2>
          <p style={styles.text}>
            For questions about these Terms of Service or our SMS notification service, please contact us:
          </p>
          <div style={styles.contactInfo}>
            <p><strong>Email:</strong> brallan.alvares@scalefoundation.org</p>
            <p><strong>Contact Name:</strong> Cristina Garcia</p>
            <p><strong>Phone:</strong> (888) 551-8653 Ext. 102</p>
            <p><strong>Address:</strong> 414 Yale Avenue Suite I, Claremont, CA 91711</p>
          </div>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>12. Governing Law</h2>
          <p style={styles.text}>
            These Terms of Service shall be governed by and construed in accordance with the laws of the 
            state where {schoolName} is located, without regard to its conflict of law provisions.
          </p>
        </div>

        <div style={styles.footer}>
          <p style={styles.footerText}>
            By using our SMS notification service, you acknowledge that you have read, understood, and 
            agree to be bound by these Terms of Service.
          </p>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    backgroundColor: '#f8f9fa',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
  },
  header: {
    backgroundColor: 'white',
    padding: '20px 40px',
    boxShadow: '0 2px 10px rgba(29, 78, 137, 0.1)',
    borderBottom: '1px solid rgba(29, 78, 137, 0.1)'
  },
  backButton: {
    color: '#1D4E89',
    textDecoration: 'none',
    fontSize: '14px',
    fontWeight: '500',
    display: 'inline-block',
    marginBottom: '20px',
    transition: 'color 0.3s ease'
  },
  logoSection: {
    display: 'flex',
    alignItems: 'center',
    gap: '15px'
  },
  logo: {
    height: '40px',
    width: 'auto'
  },
  schoolName: {
    color: '#1D4E89',
    fontSize: '24px',
    fontWeight: '600',
    margin: 0
  },
  content: {
    maxWidth: '800px',
    margin: '0 auto',
    padding: '40px 20px'
  },
  title: {
    color: '#1D4E89',
    fontSize: '36px',
    fontWeight: '700',
    marginBottom: '10px',
    textAlign: 'center'
  },
  lastUpdated: {
    color: '#666',
    fontSize: '14px',
    textAlign: 'center',
    marginBottom: '40px',
    fontStyle: 'italic'
  },
  section: {
    marginBottom: '30px',
    backgroundColor: 'white',
    padding: '25px',
    borderRadius: '12px',
    boxShadow: '0 2px 8px rgba(29, 78, 137, 0.05)',
    border: '1px solid rgba(29, 78, 137, 0.05)'
  },
  sectionTitle: {
    color: '#1D4E89',
    fontSize: '20px',
    fontWeight: '600',
    marginBottom: '15px',
    borderBottom: '2px solid rgba(29, 78, 137, 0.1)',
    paddingBottom: '8px'
  },
  text: {
    color: '#333',
    fontSize: '16px',
    lineHeight: '1.6',
    marginBottom: '15px'
  },
  list: {
    color: '#333',
    fontSize: '16px',
    lineHeight: '1.6',
    marginLeft: '20px',
    marginBottom: '15px'
  },
  contactInfo: {
    backgroundColor: 'rgba(29, 78, 137, 0.05)',
    padding: '20px',
    borderRadius: '8px',
    border: '1px solid rgba(29, 78, 137, 0.1)'
  },
  footer: {
    textAlign: 'center',
    marginTop: '40px',
    padding: '20px',
    backgroundColor: 'rgba(29, 78, 137, 0.05)',
    borderRadius: '12px',
    border: '1px solid rgba(29, 78, 137, 0.1)'
  },
  footerText: {
    color: '#1D4E89',
    fontSize: '16px',
    fontWeight: '500',
    margin: 0
  }
};

export default TermsOfService; 